import { useNavigate, useSearchParams } from "react-router-dom";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import { SecundaryButton } from "../../../components/others/ButtonSecundary";
import LavorisService from "../../../services/LavorisService";
import { useState } from "react";
import { useModal } from "../../../hooks";

export default function Fillpromotion() {
  const [searchParams, setSearchParams] = useSearchParams("");
  const { closeModal, openModal } = useModal()
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const LavorisInstance = LavorisService.getInstance();

  const handlePromotion = async () => {
    setLoading(true);
    try {
      const candidates = searchParams.get("candidates")?.split(",") || [""];
      await LavorisInstance.CompanyServices.promoteApplicant({
        candidates: candidates,
      });

      closeModal("modalPromotion")
      openModal('afterPromoted')

    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-large mx-auto">
      <p className="text-center font-normal text-lav-black-text mt-10">
        Desaparecerán de esta tabla y se agregarán a la nómina de <strong>“Mis empleados”</strong>
      </p>
      <div className="flex my-10">
        <SecundaryButton
          type="submit"
          text="Cancelar"
          styles="border-blue-500 font-bold mr-3 text-lav-black-text"
          onClick={() => setSearchParams({ modalPromotion: "hidden" })}
        />
        <PrimaryButton
          type="submit"
          text="Promover"
          styles="bg-green-500 text-white font-bold"
          onClick={handlePromotion}
          disabled={loading}
        />
      </div>
    </div>
  );
}
